import { catchError, map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { Bank } from '../../model/bank';

@Injectable()
export class BankService {
  constructor(
    private _client: HttpClient,
    private _messageService: MessageService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = `${config.apiEndpointV2}/bank`;
  }

  private readonly _endpoint: string;

  get(): Observable<Bank[]> {
    return this._client.get<Bank[]>(this._endpoint).pipe(
      map(data => data.map(item => Object.assign(new Bank(), item))),
      catchError(error => {
        this._messageService.showError(error);
        return [];
      })
    );
  }
}
